import { roleIndexEntity } from "../../domain/entities/role_index_entity";
import { roleEntity } from '../../domain/entities/role_entity'
import { RoleContract } from "../../domain/contracts/role_contract";
import http from "../../../../plugins/http-common"
import i18n from "../../../../i18n";

export const HttpRoleRepository = {
    ...RoleContract,
    model_index: roleIndexEntity,
    model: roleEntity,

    async index() {
        const res = await http.get('roles');
        const result = [];

        res.data.success.arguments.forEach(element => {
            result.push({
                id: element.id,
                name: element.name,
                is_for_clients: element.is_for_clients,
                parameters: element,
                actions: [
                    {
                        name: i18n.t('roles.edit'),
                        icon: {
                            color: 'accent',
                            icon: 'edit'
                        },
                        link: 'roles/edit/' + element.id,
                        permission: "role.update"
                    },
                    {
                        name: i18n.t('roles.delete'),
                        icon: {
                            color: 'accent',
                            icon: 'delete'
                        },
                        method: 'askDelete',
                        permission: "role.delete"
                    }
                ]
            })
        });

        return result;
    },

    async dropdown_index(is_for_clients) {
        const res = await http.get(`roles_dropdown?is_for_clients=${is_for_clients}`);

        return res;
    },

    async show(role_id) {
        const res = await http.get('roles/' + role_id);
        
        return res;
    },
    async create(data){
        const res = await http.post('roles', data);

        return res;
    },
    async update(role_id, data){
        const res = await http.put('roles/' + role_id.toString(), data);

        return res;
    },
    async delete(role_id) {
        const res = await http.delete('roles/' + role_id.toString());

        return res
    }
};